import { IFundOrderTableSearchParams } from "../../Interfaces/manualInterfaces";
import { useCallback } from "react";
import { IStepTablesSearchParam } from "../../Interfaces/stepInterfaces";
import OrderTableFilters from "../shared/OrderTableFilters";
import {
  getStepFundOrderFilterOptions,
  getStepOrderFilterOptions,
  getStepAggregationFilterOptions,
  getStepTradeFilterOptions,
  getStepErrorFilterOptions,
  getStepFailedOrderFilterOptions,
} from "../../Requests/stepRequests";

export type StepFilterMode = "fund" | "order" | "trade" | "errors" | "failedOrders" | "aggregation";

interface IProps {
  onChange: (name: string, value: any) => void;
  searchParam: IStepTablesSearchParam;
  mode: StepFilterMode;
  fundSearchParam: IFundOrderTableSearchParams;
  onFundChange: (name: string, value: any) => void;
}

const getFilterOptionsByMode: Record<
  Exclude<StepFilterMode, "fund">,
  typeof getStepOrderFilterOptions
> = {
  order: getStepOrderFilterOptions,
  aggregation: getStepAggregationFilterOptions,
  trade: getStepTradeFilterOptions,
  errors: getStepErrorFilterOptions,
  failedOrders: getStepFailedOrderFilterOptions,
};

const SearchParam = ({ onChange, searchParam, mode, fundSearchParam, onFundChange }: IProps) => {
  const getFilterOptions = useCallback(
    () => mode === "fund" ? getStepFundOrderFilterOptions(fundSearchParam) : getFilterOptionsByMode[mode](searchParam),
    [mode, searchParam, fundSearchParam],
  );
  return (
    <OrderTableFilters
      getFilterOptions={getFilterOptions}
      searchParam={mode === "fund" ? fundSearchParam : searchParam}
      accountField={mode === "fund" ? "sahraUserId" : "sahraUserid"}
      onChange={mode === "fund" ? onFundChange : onChange}
      instrumentLabel={mode === "fund" ? "نماد صندوق" : "نماد"}
    />
  );
};

export default SearchParam;
